import React, { useEffect, useState } from 'react';
import { Button, Card, Modal, Spin, Typography, message } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';

import { authAPI } from '../../services/api';

const { Title, Text } = Typography;

function Field({ label, value }) {
  const v = value === null || value === undefined || value === '' ? '-' : String(value);
  return (
    <div style={{ display: 'flex', gap: 10, marginTop: 6 }}>
      <div style={{ width: 80, color: '#666', flex: '0 0 auto' }}>{label}</div>
      <div style={{ color: '#111', flex: 1, wordBreak: 'break-all' }}>{v}</div>
    </div>
  );
}

export default function MobileUserApproval() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [approvingId, setApprovingId] = useState(null);
  const [items, setItems] = useState([]);

  const fetchList = async () => {
    setLoading(true);
    try {
      const resp = await authAPI.pendingUsers();
      setItems(Array.isArray(resp?.data) ? resp.data : []);
    } catch (e) {
      message.error('获取待审批用户失败');
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchList();
  }, []);

  const handleApprove = (record) => {
    if (!record?.id) return;
    Modal.confirm({
      title: '确认审批',
      content: (
        <div>
          <div>{`确定要审批通过用户"${record.username || record.id}"吗？`}</div>
          <div style={{ color: 'red', marginTop: 8 }}>此操作无法撤销，审批通过后该用户将可以登录系统。</div>
        </div>
      ),
      okText: '确认审批',
      cancelText: '取消',
      okButtonProps: { danger: true },
      onOk: async () => {
        setApprovingId(record.id);
        try {
          const resp = await authAPI.approveUser(record.id);
          const ok = !!resp?.data?.ok;
          if (ok) {
            message.success('审批成功');
          } else {
            message.error('审批失败');
          }
          await fetchList();
        } catch (e) {
          message.error(e?.response?.data?.detail || '审批失败');
        } finally {
          setApprovingId(null);
        }
      },
    });
  };

  const formatCreatedAt = (date) => {
    return date ? moment.utc(date).utcOffset(8).format('YYYY-MM-DD HH:mm:ss') : '-';
  };

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f5f5f5' }}>
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 10,
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          padding: '16px 16px 12px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, color: '#fff', fontWeight: 600 }}>
            用户审批
          </Title>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              size="small"
              onClick={fetchList}
              disabled={loading}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              刷新
            </Button>
            <Button
              size="small"
              onClick={() => navigate('/permissions', { replace: true })}
              style={{
                background: 'rgba(255,255,255,0.2)',
                borderColor: 'rgba(255,255,255,0.3)',
                color: '#fff',
                backdropFilter: 'blur(10px)',
              }}
            >
              返回
            </Button>
          </div>
        </div>
      </div>

      <div style={{ flex: 1, overflow: 'auto', padding: '20px 16px 16px' }}>
        {loading ? (
          <div style={{ textAlign: 'center', padding: 50 }}>
            <Spin />
          </div>
        ) : (
          <div>
            {(items || []).map((row, idx) => (
              <Card key={row?.id ?? idx} style={{ borderRadius: 10, marginBottom: 12 }} styles={{ body: { padding: 12 } }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10, marginBottom: 8 }}>
                  <div style={{ fontWeight: 700, color: '#1677ff' }}>{row?.username || `用户 ${idx + 1}`}</div>
                  <Button size="small" type="primary" danger loading={approvingId === row.id} icon={<CheckOutlined />} onClick={() => handleApprove(row)}>
                    审批通过
                  </Button>
                </div>
                <Field label="用户ID" value={row?.id} />
                <Field label="邮箱" value={row?.email} />
                <Field label="创建时间" value={formatCreatedAt(row?.created_at)} />
              </Card>
            ))}

            {!items || items.length === 0 ? (
              <Card style={{ borderRadius: 10 }} styles={{ body: { padding: 12 } }}>
                <Text type="secondary">暂无待审批用户</Text>
              </Card>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
